import { Mail, Phone, MapPin, Sprout } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext.tsx";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="mt-12 text-white bg-green-600">
      <div className="container px-4 py-8 mx-auto">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Branding */}
          <div>
            <div className="flex items-center mb-4 space-x-3">
              <div className="p-2 bg-green-600 rounded-lg">
                <Sprout className="w-5 h-5 text-white" />
              </div>
              <h3 className="text-lg font-semibold">{t('header.appName')}</h3>
            </div>
            <p className="text-sm text-green-100">
              {t('footer.empowering')}
            </p>
          </div>
          {/* Quick Links */}
          <div>
            <h4 className="mb-4 font-semibold">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2 text-sm text-green-100">
              <li><a href="#" className="transition-colors hover:text-white">{t('footer.cropAnalysis')}</a></li>
              <li><a href="#" className="transition-colors hover:text-white">{t('footer.weatherForecast')}</a></li>
              <li><a href="#" className="transition-colors hover:text-white">{t('footer.pestManagement')}</a></li>
              <li><a href="#" className="transition-colors hover:text-white">{t('footer.aiAdvisor')}</a></li>
            </ul>
          </div>
          {/* Resources */}
          <div>
            <h4 className="mb-4 font-semibold">{t('footer.resources')}</h4>
            <ul className="space-y-2 text-sm text-green-100">
              <li><a href="#" className="transition-colors hover:text-white">{t('footer.farmingGuide')}</a></li>
              <li><a href="#" className="transition-colors hover:text-white">{t('footer.bestPractices')}</a></li>
              <li><a href="#" className="transition-colors hover:text-white">{t('footer.communityForum')}</a></li>
              <li><a href="#" className="transition-colors hover:text-white">{t('footer.supportCenter')}</a></li>
            </ul>
          </div>
          {/* Contact */}
          <div>
            <h4 className="mb-4 font-semibold">{t('footer.contactUs')}</h4>
            <div className="space-y-3 text-sm text-green-100">
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4" />
                <span>{t('footer.support')}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4" />
                <span>{t('footer.phone')}</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4" />
                <span>{t('footer.address')}</span>
              </div>
            </div>
          </div>
        </div>
        {/* Bottom footer */}
        <div className="flex flex-col items-center justify-between pt-6 mt-8 border-t border-green-700 md:flex-row">
          <p className="text-sm text-green-100">
            {t('footer.copyright')}
          </p>
          <div className="flex mt-4 space-x-4 md:mt-0">
            <a href="#" className="text-sm text-green-100 transition-colors hover:text-white">{t('footer.privacyPolicy')}</a>
            <a href="#" className="text-sm text-green-100 transition-colors hover:text-white">{t('footer.termsOfService')}</a>
            <a href="#" className="text-sm text-green-100 transition-colors hover:text-white">{t('footer.help')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}